import { getPath } from "../../utils";
import ActionTypes from "../actions/ActionTypes";

const initialState = {
  fleetCoachDriverMappingList: [],
  prevPage: -1,
  nextPage: -1,
  activeFilters: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_FLEET_COACH_DRIVER_MAPPING_LIST:
      return setFleetCoachDriverMappingList(state, action);
    case ActionTypes.SET_FLEET_COACH_DRIVER_MAPPING_ACTIVE_FILTERS:
      return setFleetCoachDriverMappingActiveFilters(state, action);
    default:
      return state;
  }
}

const setFleetCoachDriverMappingList = (state, action) => {
  return {
    ...state,
    fleetCoachDriverMappingList: getPath(action.payload, "mappings", []),
    prevPage: getPath(action.payload, "page_response.previous_page", -1),
    nextPage: getPath(action.payload, "page_response.nextPage", -1),
  };
};

const setFleetCoachDriverMappingActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
